import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@creatureType type, Термин на русском}
export const CreatureTypePlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link route={'glossaryItem'} params={{id: 'creature-type'}} title={title} className={linkClass('creatureType')}>
			{title}
		</Link>
	);
};
